import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getIcon } from '../../util/icons';

class TrackFunnelTaskModal extends Component{

  componentWillMount(){

  }

  markComplete(){
    this.props.updateStatus('complete');
  }
  markFailed(){
    this.props.updateStatus('failed');
  }
  markIncomplete(){
    this.props.updateStatus('incomplete');
  }

  render(){

    const { funnelTask, syncingFunnelTask, currentTaskStatus } = this.props;

    return (
      <div className="modal track-imperative-task">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <h2>{funnelTask.text}</h2>
          </div>
          {syncingFunnelTask &&
            <div className="modal-actions">
              <p className="updating-text">Updating checklist item...</p>
            </div>
          }
          {!syncingFunnelTask &&
            <div className="modal-actions">
              <button onClick={this.markComplete.bind(this)} className="button primary">Mark complete</button>
              <button onClick={this.markFailed.bind(this)} className="button align-with-normal-button-size danger-button button-sm">Mark at risk</button>

              {currentTaskStatus !== 'incomplete' &&
                <button onClick={this.markIncomplete.bind(this)} className="button align-with-normal-button-size grey-button button-sm">Mark incomplete</button>
              }
              {currentTaskStatus === 'incomplete' &&
                <button onClick={this.props.hide} className="button align-with-normal-button-size grey-button button-sm">Cancel</button>
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default TrackFunnelTaskModal;



// WEBPACK FOOTER //
// ./src/components/modals/trackFunnelTask.js